import { put, call, takeLatest, takeEvery } from 'redux-saga/effects';
import PricingAPI from './PricingsAPI';
import {
  fetchPricingSuccess,
  fetchPricingFail,
  uploadPricingSuccess,
  uploadPricingFail,
  deletePricingSuccess,
  deletePricingFail
} from './actions';
import { parseApiError } from '../../util/api';
import { showNotification } from '../../notifications/actions';
import {
  ADMIN_PRICING_FETCH,
  ADMIN_PRICING_UPLOAD,
  ADMIN_PRICING_DELETE
} from './constants';

function *fetchPricings () {
  try {
    const { data } = yield call(PricingAPI.fetchPricings);
    if (Array.isArray(data.pricings)) {
      yield put(fetchPricingSuccess(data.pricings));
    } else {
      let msg = 'unexpected response fetching pricing data';
      yield put(fetchPricingFail(msg));
      yield put(showNotification(
        'Failed to load pricing records', msg, 'error', 10
      ));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchPricingFail(msg));
    yield put(showNotification(
      'Failed to load pricing records', msg, 'error', 10
    ));
  }
}

function *uploadPricing (action) {
  try {
    yield call(PricingAPI.uploadPricing, action.pricing);
    yield put(uploadPricingSuccess(action.pricing));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(uploadPricingFail(action.pricing, msg));
    yield put(showNotification(
      'Failed to upload pricing data', msg, 'error', 10
    ));
  }
}

function *deletePricing (action) {
  try {
    yield call(PricingAPI.deletePricing, action.pricing.id);
    yield put(deletePricingSuccess());
  } catch (error) {
    const msg = parseApiError(error);
    yield put(deletePricingFail(action.pricing, msg));
    yield put(showNotification(
      'Failed to upload pricing data', msg, 'error', 10
    ));
  }
}

function *pricingsSagas () {
  yield takeLatest(ADMIN_PRICING_FETCH, fetchPricings);
  yield takeEvery(ADMIN_PRICING_UPLOAD, uploadPricing);
  yield takeEvery(ADMIN_PRICING_DELETE, deletePricing);
}

export default pricingsSagas;
